var _defs, _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: #FFA50D;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 17,
    height: 17,
    rx: 2,
    ry: 2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m15,0H2C.9,0,0,.9,0,2v13c0,1.1.9,2,2,2h13c1.1,0,2-.9,2-2V2c0-1.1-.9-2-2-2Zm1,15c0,.55-.45,1-1,1H2c-.55,0-1-.45-1-1V2c0-.55.45-1,1-1h13c.55,0,1,.45,1,1v13Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m12.22,7.46l-2.87-3.66c-.19-.26-.55-.33-.81-.14-.06.04-.1.09-.14.14l-2.87,3.67c-.23.3-.21.72.03,1.01.1.12.24.19.39.21.15.01.31-.03.42-.13.04-.03.08-.07.1-.11l1.75-2.24v5.89c-.07.35.16.69.51.77.04,0,.09.01.13.01.3,0,.57-.21.64-.52.02-.08.02-.17,0-.23v-5.92l1.76,2.24c.11.15.29.24.49.25.17,0,.33-.08.44-.21.25-.29.26-.7.03-1.01Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.4068d97a.svg";
export { ForwardRef as ReactComponent };